<template>
<!--  <font-awesome-icon icon="cog" spin v-if="!this.$store.state.$account "/>-->
  <div class="d-flex flex-row align-content-center align-items-center">
    <img
      src="/img/switch-user.png"
      alt="Switch User"
      v-if="isMultiUser"
      class="mr-3"
      style="cursor: pointer; width: 2.5rem; height: 1.8rem;"
      @click="toggleSwitchUserKeypad"
    />
    
  <span class="small">{{firstName}}</span>
  <div v-if="picUrl === null" class="empty-image mx-2">
    
  </div>
  <div v-else>
    <img
    class="mx-1"
    :src="$config.files.baseurlimage + picUrl"
    width="30px"
    height="30px"
    style="border-radius: 50%"
    />
  </div>
  <SwitchAccountKeypad @closeSwitchAccountKeypad="toggleSwitchUserKeypad(false)" :picUrl="picUrl" v-if="showSwitchUserKeypad"/>
  <SwitchAccountKeypad @closeSwitchAccountKeypad="toggleSwitchUserKeypad(false)" :noOverride="true" :picUrl="picUrl" v-if="requiredPin"/>
  </div>
<!--  <AppHeaderDropdown v-else :right="$dir.ltr">-->
<!--    <template slot="header">-->
<!--      <font-awesome-icon icon="user-circle" size="lg" class="mx-1"/>-->
<!--    </template>-->
<!--    <template slot="dropdown">-->
<!--      <b-dropdown-header tag="div" class="text-center"><strong>{{$t('account.Account')}}</strong></b-dropdown-header>-->
<!--      <b-dropdown-item @click="logout">-->
<!--        <i><font-awesome-icon icon="power-off" class="text-danger"/></i>-->
<!--        {{$t('account.Logout')}}-->
<!--      </b-dropdown-item>-->
<!--    </template>-->
<!--  </AppHeaderDropdown>-->

</template>

<script>

import SwitchAccountKeypad from '../account/SwitchAccountKeypad.vue'
import * as types from '@/store/types'
import { HeaderDropdown as AppHeaderDropdown } from './core'

export default {
  name: 'account',
  components: {
    AppHeaderDropdown,
    SwitchAccountKeypad
  },
  props: {
    picUrl: {
      required: true
    },
    firstName: {
      required: true
    },
    UserID: {
      required: true
    },
  },
  data() {
    return {
      showSwitchUserKeypad:false,
      requiredPin:false,
      isMultiUser: true//for now
    }
  },
  watch: {
    '$store.state.requiredPin': {
      handler: function(newVal) {
        this.requiredPin = newVal
      },
      immediate: true
    }
  },
  created(){
   
    if(localStorage.getItem("requirePin") == 'true'){//user refreshed the page to bypass the pin(not on my watch)
      this.requiredPin = true
    }else{
      this.requiredPin = false
    }
    let fontAvailable;
    document.fonts.ready.then(() => {
      fontAvailable = document.fonts.check("16px mp.ttf");
      if(fontAvailable)
        this.isMultiUser = true;
    }).catch(err=>err);
  },
  methods: {
    logout () {
      if (!this.progressing) {
        this.$api.profileUser.logout()
        .catch(() => {})
        .then(() => {
          this.$store.commit(types.LOGOUT)
        })
      }
    },
    toggleSwitchUserKeypad(option = null){
      if(option === null)
        return this.showSwitchUserKeypad = !this.showSwitchUserKeypad
      this.showSwitchUserKeypad = option
    }
  }
}
</script>
<style scoped>
  .empty-image{
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: url("../../assets/image/Iconmap.png")  no-repeat -140px -364px;;
  }
</style>
